import outlet from "fragments/news/outlet"
import { gql } from "graphql-tag"

const GET_OUTLETS = gql`
  ${outlet}

  query getOutlets($query: GetQueryOutlets) {
    getOutlets(query: $query) {
      ...Outlet
    }
  }
`

export default GET_OUTLETS
